import styled from 'styled-components'
import {
  backgroundDocument,
  backgroundSelected,
  textSelected,
  GrayLight,
  GrayLightBorder
} from '../../constants/constants'
import { Button } from 'antd'
import { Pencil } from '@styled-icons/evil/Pencil'
import { Profile } from '@styled-icons/icomoon/Profile'
import { ClipboardCheck } from '@styled-icons/bootstrap/ClipboardCheck'
import { FileEarmarkPdf } from '@styled-icons/bootstrap/FileEarmarkPdf'
import { BoxArrowLeft } from '@styled-icons/bootstrap/BoxArrowLeft'
import { Question } from '@styled-icons/bootstrap/Question'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
export const NavSpan = styled.span``

export const NavSpanSelected = styled.span`
  color: ${textSelected};
`

export const ButtonAntd = styled(Button)`
  background-color: ${(props) => (props.$showasselected ? backgroundSelected : backgroundDocument)};
  border-color: ${(props) => (props.$showasselected ? textSelected : GrayLightBorder)};
  border-bottom: none;
  font-weight: bold;
`
export const PencilButton = styled(Pencil)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-bottom: 3px;
  margin-top: -3px;
`

export const ProfileButton = styled(Profile)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-bottom: 3px;
`
export const AuditButton = styled(ClipboardCheck)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-bottom: 3px;
`
export const FileEarmarkPdfIcon = styled(FileEarmarkPdf)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-right: 2px;
  margin-bottom: 5px;
`

export const LogoutIcon = styled(BoxArrowLeft)`
  color: ${GrayLight};
  margin-left: -10px;
  margin-right: 2px;
  margin-bottom: 5px;
`

export const QuestionIcon = styled(Question)`
  color: black;
  margin-left: -5px;
  margin-bottom: 5px;
`
